import { HubConnectionState, type HubConnection } from "@microsoft/signalr";
import { createContext } from "react";

export const SignalRContext = createContext<{
    connection: HubConnection | null;
    connectionState: HubConnectionState;
    startConnection: () => Promise<HubConnection | null>;
    stopConnection: () => Promise<void>;
}>({
    connection: null,
    connectionState: HubConnectionState.Disconnected,
    startConnection: async () => null,
    stopConnection: async () => undefined
});
